// eslint-disable-next-line import/prefer-default-export
export const LOAD_INVITES = "patients/LOAD_INVITES";
export const USER_ALREADY_EXISTS = "patients/USER_ALREADY_EXISTS";
export const RESET_FORM_VALUES = "patients/RESET_FORM_VALUES";
export const LOAD_PAIRING_PRACTITIONERS = "patients/LOAD_PAIRING_PRACTITIONERS";
export const LOADED_DATA = "patients/LOADED_DATA";
